import {
	PanelBody,
	SelectControl,
	ToggleControl,
	RangeControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import ColorPicker from '../../../../components/ColorPicker';
import { CHART_TYPE_OPTIONS } from '../chart-types';

const PALETTE_OPTIONS = [
	{ label: __( 'For light backgrounds', 'brandy-blocks' ), value: 'light' },
	{ label: __( 'For dark backgrounds', 'brandy-blocks' ), value: 'dark' },
];

export default function ChartSettings( { attributes, setAttributes, config } ) {
	const isBar = 'bar' === config.type;
	const canStack = isBar || 'area' === config.type;

	return (
		<PanelBody title={ __( 'Chart', 'brandy-blocks' ) }>
			<SelectControl
				__nextHasNoMarginBottom
				__next40pxDefaultSize
				label={ __( 'Type', 'brandy-blocks' ) }
				value={ attributes.chartType }
				options={ CHART_TYPE_OPTIONS.map( ( { value, label } ) => ( {
					value,
					label,
				} ) ) }
				onChange={ ( value ) =>
					setAttributes( { chartType: value } )
				}
			/>

			{ isBar && (
				<SelectControl
					__nextHasNoMarginBottom
					__next40pxDefaultSize
					label={ __( 'Direction', 'brandy-blocks' ) }
					value={ attributes.orientation }
					help={ __(
						'Horizontal reads better when the category names are long.',
						'brandy-blocks'
					) }
					options={ [
						{
							label: __( 'Vertical columns', 'brandy-blocks' ),
							value: 'vertical',
						},
						{
							label: __( 'Horizontal bars', 'brandy-blocks' ),
							value: 'horizontal',
						},
					] }
					onChange={ ( value ) =>
						setAttributes( { orientation: value } )
					}
				/>
			) }

			{ canStack && (
				<ToggleControl
					__nextHasNoMarginBottom
					label={ __( 'Stack the series', 'brandy-blocks' ) }
					help={ __(
						'Stack when the series add up to a meaningful whole; keep them side by side when the reader needs to compare them.',
						'brandy-blocks'
					) }
					checked={ !! attributes.stacked }
					onChange={ ( value ) => setAttributes( { stacked: value } ) }
				/>
			) }

			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Height (px)', 'brandy-blocks' ) }
				value={ attributes.plotHeight }
				min={ 120 }
				max={ 720 }
				step={ 10 }
				onChange={ ( value ) =>
					setAttributes( { plotHeight: value ?? 320 } )
				}
			/>

			<SelectControl
				__nextHasNoMarginBottom
				__next40pxDefaultSize
				label={ __( 'Colours', 'brandy-blocks' ) }
				value={ attributes.paletteName }
				help={ __(
					'Both palettes are checked for colourblind separation and contrast. Pick the one that matches the section behind the chart.',
					'brandy-blocks'
				) }
				options={ PALETTE_OPTIONS }
				onChange={ ( value ) =>
					setAttributes( { paletteName: value } )
				}
			/>

			<div className="brandy-chart-control">
				<span className="brandy-chart-control__label">
					{ __( 'Surface colour', 'brandy-blocks' ) }
				</span>
				<ColorPicker
					color={ attributes.surfaceColor }
					onChange={ ( value ) =>
						setAttributes( { surfaceColor: value || '' } )
					}
				/>
				<p className="brandy-chart-control__help">
					{ __(
						'Fills the gaps between slices and the ring around line markers. Set it to the background this chart sits on.',
						'brandy-blocks'
					) }
				</p>
			</div>
		</PanelBody>
	);
}
